import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import Hammer from 'hammerjs'

export default function TouchWrapper({
  children,
  className,
  onSwipe,
  onPress,
  onTouch
}) {
  const wrapperRef = useRef(null)

  // We remove the listeners whenever the props change below to avoid the
  // event handlers being bound to the wrong state. See
  //  https://stackoverflow.com/questions/53845595/wrong-react-hooks-behaviour-with-event-listener
  useEffect(() => {
    const hammer = Hammer(wrapperRef.current)
    const onSwipeLeft = () => onSwipe('left')
    const onSwipeRight = () => onSwipe('right')

    if (onSwipe) {
      hammer.on('swipeleft', onSwipeLeft)
      hammer.on('swiperight', onSwipeRight)
    }

    if (onPress) {
      hammer.on('press', onPress)
    }

    if (onTouch) {
      hammer.on('tap', onTouch)
    }

    return () => {
      if (onSwipe) {
        hammer.off('swipeleft', onSwipeLeft)
        hammer.off('swiperight', onSwipeRight)
      }

      if (onPress) {
        hammer.off('press', onPress)
      }

      if (onTouch) {
        hammer.off('tap', onTouch)
      }
    }
  }, [onSwipe, onPress, onTouch])

  return (
    <div className={className} ref={wrapperRef}>
      {children}
    </div>
  )
}

TouchWrapper.propTypes = {
  className: PropTypes.string,
  onSwipe: PropTypes.func,
  onPress: PropTypes.func,
  onTouch: PropTypes.func
}
